import React from 'react';

export default function SubNavlink({ subNavlink }) {
  const { label, subLabel } = subNavlink;
  return (
    <>
      {subNavlink && (
        <div className="sub-navlink">
          {label && (
            <div className="sub-navlink__title">{subNavlink.label}</div>
          )}
          {subLabel && (
            <div className="body --x-small --emphasized">
              {subNavlink.subLabel}
            </div>
          )}
        </div>
      )}
    </>
  );
}
